import React, { forwardRef, useState } from 'react';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { nanoid } from 'nanoid';
import PermissionButton from '@product-framework/components/PermissionButton';
import { HIDE_ADD_CLAIM_BUTTON_WHEN_STATUS } from '@constants/app';
import ClaimDetailDialog from './components/ClaimDetailDialog';
import JobClaimHistory from './components/JobClaimHistory';

const Claims = forwardRef((props, ref) => {
  const [currentClaimId, setCurrentClaimId] = useState(null);
  const [showAddClaim, setShowAddClaim] = useState(false);
  const [open, setOpen] = useState(false);
  const [historyId, setHistoryId] = useState('initial');
  const { getValues } = useFormContext();
  const jobId = getValues('id');
  const serviceJobStatus = getValues('serviceJobStatus');
  const serviceJobFormData = getValues('serviceJobFormData');

  return (
    <Box ref={ref}>
      {showAddClaim && (
        <Box mb={1} textAlign="right">
          <PermissionButton
            permissionName="CAN_ADD_NEW_CLAIM"
            variant="contained"
            size="small"
            onClick={() => setOpen(true)}>
            Add new claim
          </PermissionButton>
        </Box>
      )}
      {open && (
        <ClaimDetailDialog
          serviceJobId={jobId}
          claimId={currentClaimId}
          open={open}
          onClose={() => {
            setCurrentClaimId(null);
            setOpen(false);
            setHistoryId(nanoid());
            props?.forceInitializeForm();
          }}
          serviceJobStatus={serviceJobStatus}
          serviceJobFormData={serviceJobFormData}
        />
      )}
      <JobClaimHistory
        key={historyId}
        jobId={jobId}
        setCurrentClaimId={setCurrentClaimId}
        setOpen={setOpen}
        setShowAddClaim={setShowAddClaim}
        hideAddClaimStatuses={HIDE_ADD_CLAIM_BUTTON_WHEN_STATUS}
      />
    </Box>
  );
});

export default Claims;
